import { createFileRoute } from "@tanstack/react-router";
import LackOfSleepMentalHealthPage from "@/pages/articles/LackOfSleepMentalHealthPage";
export const Route = createFileRoute(
  "/lack-of-sleep-is-compromising-the-mental-health-of-78-of-adults",
)({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Lack of Sleep & Mental Health | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Lack of sleep compromises mental health. Learn how insomnia worsens depression and what TMS can do to help in Coral Springs, FL Free consultation available.",
        },
        {
          property: "og:title",
          content: "Lack of Sleep & Mental Health | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Lack of sleep compromises mental health. Learn how insomnia worsens depression and what TMS can do to help in Coral Springs, FL Free consultation available.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/lack-of-sleep-is-compromising-the-mental-health-of-78-of-adults",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/lack-of-sleep-is-compromising-the-mental-health-of-78-of-adults",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <LackOfSleepMentalHealthPage />;
}
